// ** React Imports
import { createContext, useEffect, useState } from 'react'

// ** Next Import
import { useNavigate } from 'react-router-dom'


// ** Axios
import axios from 'axios'

// ** Config
import { userData } from '..//hooks/userData'

// ** Defaults
const defaultProvider = {
  scCompletedCount: null,
  scPendingCount: null,
  scNotSubmited: null,
  selectedUserData: null,
  loading: false,
  setSelectedUserData: () => null,
  setLoading: () => Boolean,
  completedClaim: () => Promise.resolve(),
  // setTotalCounts:() => null
}
const TrueClaimContext = createContext(defaultProvider)

const TrueClaimProvider = ({ children }) => {
  const navigate = useNavigate()
  const [selectedUserData, setSelectedUserData] = useState(null)

  const [totalCounts, setTotalCounts] = useState({
    otp_less: 0,
    payment: 0,
    return: 0,
    lost: 0,
  })
  const [claimType, setClaimType] = useState('')

  const [tcPendingPaymentNotReceive, setTcPendingPaymentNotReceive] = useState(null)
  const [tcPendingPaymentNotReceiveUserList, setTcPendingPaymentNotReceiveUserList] = useState(null)

  const [scCustomerReturnCompleteCount, setScCustomerReturnCompleteCount] = useState(0)


  const [loading, setLoading] = useState(defaultProvider.loading)
  const [loadingById, setLoadingById] = useState(false)
  const [isUpdateLoading, setIsUpdateLoading] = useState(false)
  const [error, setError] = useState('')
  const userdata = userData()


  const trueClaim = async (params) => {
    let token = JSON.parse(localStorage.getItem("userData"))

    setLoading(true)
    await axios
      .post(`${process.env.REACT_APP_BASE_URL}/order/count`, params, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(async response => {
        const excludeIds = [33, 27, 44, 50, 561, 979]; // List of IDs to exclude

        const customer_return_pending = response.data.reduce((acc, item) => {
          if (excludeIds.includes(item.gstId)) {
            return acc; // Skip this item
          }

          acc[item.gstId] = (acc[item.gstId] || 0) + item.count;

          return acc;
        }, {});


        let newClaimType = "";
        if (params.intransit) newClaimType = "otp_less";
        else if (params.returnNotReceived) newClaimType = "return";
        else if (params.orderType === "LOST") newClaimType = "lost";
        else if (params.paymentNotReceived) newClaimType = "payment";
        setClaimType(newClaimType);

        setTcPendingPaymentNotReceive(customer_return_pending)

      })
      .catch((error) => {
        setTcPendingPaymentNotReceive(null)
        if (error.response.status === 403) {
          localStorage.removeItem("userData")
          navigate('/login')
        } else {
          setError('Something Went Wrong')
          setTimeout(() => {
            setError('')
          }, 3000);
        }
        setLoading(false)
      }).finally(() => {
        // setLoading(false)
      })
  }

  useEffect(() => {
    if (userdata.user && tcPendingPaymentNotReceive) {
      let matchedRecords
      if (claimType === 'payment') {
        // console.log('=-=-=-=', matchedRecords = userdata.user
        //   .filter(record =>
        //     tcPendingPaymentNotReceive.hasOwnProperty(record.id) && !record.cancelledCheque
        //   ).map(data => ({
        //     companyName: data.companyName,
        //     platformEmail: data.platformEmail,
        //     mobile: data.user.mobile,
        //     email: data.user.email,
        //     cancelledCheque: data.cancelledCheque
        //   }))
        // )
        // console.log('=-=-=-=', matchedRecords = userdata.user
        //   .filter(record =>
        //     tcPendingPaymentNotReceive.hasOwnProperty(record.id) && record.cancelledCheque
        //   ))   --- 374
        // console.log('=-=-=-=', matchedRecords = userdata.user
        //   .filter(record =>
        //     tcPendingPaymentNotReceive.hasOwnProperty(record.id) &&
        //     record.cancelledCheque &&
        //     record.cancelledCheque.startsWith("https://drive.google.com")
        //   ))  -- 350
        // console.log('=-=-=-=', matchedRecords = userdata.user
        //   .filter(record =>
        //     tcPendingPaymentNotReceive.hasOwnProperty(record.id)
        //   ))  -- 522
        matchedRecords = userdata.user
          .filter(record =>
            tcPendingPaymentNotReceive.hasOwnProperty(record.id) && record.cancelledCheque
          )
          .map(record => ({
            platformEmail: record.platformEmail,
            id: record.id,
            email: record.user.email,
            companyName: record.companyName,
            cancelledCheque: record.cancelledCheque,
            count: tcPendingPaymentNotReceive[record.id]
          }));

      } else {
        matchedRecords = userdata.user
          .filter(record => tcPendingPaymentNotReceive.hasOwnProperty(record.id)) // Check existence first
          .map(record => ({
            platformEmail: record.platformEmail,
            id: record.id,
            email: record.user.email,
            companyName: record.companyName,
            cancelledCheque: record.cancelledCheque,
            count: tcPendingPaymentNotReceive[record.id]
          }));
      }

      const totalCount = matchedRecords.reduce((sum, record) => sum + record.count, 0);

      setTotalCounts((prev) => ({
        ...prev,
        [claimType]: totalCount,
      }));
      setScCustomerReturnCompleteCount(totalCount);
      setTcPendingPaymentNotReceiveUserList(matchedRecords)
      setLoading(false)

    }
  }, [userdata.user, tcPendingPaymentNotReceive])



  const getRecordById = (params, errorCallback) => {
    let token = JSON.parse(localStorage.getItem("userData"))

    if (!token) {
      if (errorCallback) errorCallback('Authentication error: No token found.')

      return
    }
    // setLoadingById(true)

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/order/list`, params, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(async response => {
        // console.log('response.data', response.data)
        setLoadingById(false)
        setSelectedUserData(response.data)
        if (errorCallback) errorCallback({ status: 'success' })
      })
      .catch(err => {
        setSelectedUserData(null)
        if (errorCallback) errorCallback({ status: 'error' })
      }).finally(() => {
        setLoadingById(false)
      })
  }

  const getRecordExport = (params, errorCallback) => {
    let token = JSON.parse(localStorage.getItem("userData"))

    if (!token) {
      if (errorCallback) errorCallback('Authentication error: No token found.')

      return
    }
    setLoadingById(true)

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/order/export`, params, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(async response => {
        if (errorCallback) errorCallback({ status: 'success' })
      })
      .catch(err => {
        if (errorCallback) errorCallback({ status: 'error' })
      }).finally(() => {
        setLoadingById(false)
      })
  }

  const updateTicketId = (params, errorCallback) => {
    let token = JSON.parse(localStorage.getItem("userData"))
    if (!token) {
      if (errorCallback) errorCallback('Authentication error: No token found.')

      return
    }
    setIsUpdateLoading(true)

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/true-claims`, params, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(async response => {
        if (errorCallback) errorCallback({ status: 'success', response: response.data })
      })
      .catch(err => {
        if (errorCallback) errorCallback({ status: 'error' })
      }).finally(() => {
        setIsUpdateLoading(false)
      })
  }

  const deleteTicketId = (params, errorCallback) => {
    let token = JSON.parse(localStorage.getItem("userData"))
    if (!token) {
      if (errorCallback) errorCallback('Authentication error: No token found.')

      return
    }
    setIsUpdateLoading(true)

    axios
      .delete(`${process.env.REACT_APP_BASE_URL}/true-claims/${params}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(async response => {
        if (errorCallback) errorCallback({ status: 'success' })
      })
      .catch(err => {
        if (errorCallback) errorCallback({ status: 'error' })
      }).finally(() => {
        setIsUpdateLoading(false)
      })
  }

  const values = {
    scCustomerReturnCompleteCount,
    tcPendingPaymentNotReceiveUserList,

    selectedUserData,
    loading,
    totalCounts,
    setLoading,
    loadingById,
    isUpdateLoading,
    error,
    setLoadingById,
    getRecordById: getRecordById,
    deleteTicketId,
    setSelectedUserData,
    // completedClaim: completedClaim,
    tcPendingPaymentNotReceive,
    getRecordExport: getRecordExport,
    updateTicketId,
    trueClaim,
    setTotalCounts
  }

  return <TrueClaimContext.Provider value={values}>{children}</TrueClaimContext.Provider>
}

export { TrueClaimContext, TrueClaimProvider }
